import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IsLoggedInGuard } from './_guard/is-logged-in.guard';
import { IsNotLoggedInGuard } from './_guard/is-not-logged-in.guard';

const routes: Routes = [{ path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule), canLoad: [IsNotLoggedInGuard] }, 
{ path: 'forgot', loadChildren: () => import('./forgot/forgot.module').then(m => m.ForgotModule), canLoad: [IsNotLoggedInGuard] },
{ path: 'preview', loadChildren: () => import('./preview/preview.module').then(m => m.PreviewModule) },
{ path: '', loadChildren: () => import('./main/main.module').then(m => m.MainModule), canLoad: [IsLoggedInGuard] }];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
